import {
  Component,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { environment } from 'environments/environment';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { MediaQueriesService } from '../../../shared/services/utilities/media-queries.service';

declare var require: any;

@Component({
  selector: 'app-kazaplan-viewer',
  templateUrl: './kazaplan-viewer.component.html',
  styleUrls: ['./kazaplan-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KazaplanViewerComponent implements OnChanges {
  @Input() planId = null;
  @Input() htmlId = null;

  @HostBinding('class.kz-kaza-plan3d--preview') hostClass = true;

  public browserIsValid = false;
  private kazaplanInstance = null;
  scriptLoaded = false;

  private config: any = {
    locale: 'fr-FR',
    env: environment.KAZAPLAN_ENV,
    environment: environment.KAZAPLAN_ENVIRONMENT,
    appId: 'Kozikaza',
    partnerKey: environment.KAZAPLAN_KEY,
    mode: 'viewer',
    plan: {
      id: null
    }
  };

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(DOCUMENT) private doc: any,
    public mediaQueriesService: MediaQueriesService
  ) {}

  ngOnChanges(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.mediaQueriesService.detectIE()) {
        this.browserIsValid = true;
        this.config.plan.id = this.planId;
        this.initApp();
        this.loadScript();
      } else {
        this.browserIsValid = false;
        throw new Error('Kozikaza / Kazaplan.component | Try to open plan from IE detected');
      }
    }
  }

  loadScript() {
    if (this.scriptLoaded) {
      return;
    }
    this.scriptLoaded = true;

    const loadScript = require('simple-load-script');
    loadScript(environment.KAZAPLAN_SCRIPT + '?no-cache=' + new Date().getTime())
      .then(() => {});
  }

  initApp() {
    window['kzpAsyncInit'] = () => {
      window['KZP'].init(this.htmlId ? '#' + this.htmlId : '#kazaplan-viewer', {
        ...this.config,
        onReady: (app) => {
          this.kazaplanInstance = app;
        }
      });
    };
  }
}
